<div class="container">
  <div class="row d-flex justify-content-center py-5">
    <div class="col-sm-10 col-md-6 col-lg-4 p-5 card">

      <!-- LOGO -->
      <div class="row d-flex justify-content-center mb-4">
        <div class="d-flex col-md-8"><img alt="ZeroFlex" src="../../../../assets/images/logo.png" id="logo" class="img-fluid"></div>
      </div>

      <ng-content></ng-content>

    </div>
  </div>
</div>
